import ErrorResponse from './BgMaxPrice/ErrorResponse';

export const retryFetchAfterUserProductGroupLock = async <Response>(
	fetch: () => Promise<Response>,
	repeatInMilliseconds = 1000
): Promise<Response> => {
	const fetchWithRetry = async (): Promise<Response> => {
		try {
			return await fetch();
		} catch (error) {
			if ((error as ErrorResponse).handleProductGroupLocked()) {
				return new Promise((resolve) =>
					setTimeout(() => {
						resolve(fetchWithRetry());
					}, repeatInMilliseconds)
				);
			}
			throw error;
		}
	};

	return fetchWithRetry();
};
